import ValidationDialog from "../../Common/ValidationDialog/ValidationDialog.vue";
import TreeViewSelection from "../../Common/TreeViewSelection/TreeViewSelection.vue";
import LocationMap from "../../Common/LocationMap/LocationMap.vue";
import moment from "moment";
import EventImagePreview from "../../Events/EventImagePreview/EventImagePreview.vue";

export default {
  name: "BookingEditView",
  components: {
    EventImagePreview,
    LocationMap,
    TreeViewSelection,
    ValidationDialog
  },
  props: ["servicePackage", "featureGroups", "accommodationTypes", "dialog"],
  data: () => ({
    editorUrl: "https://cdn.eberl-online.cloud/ckeditor5/ckeditor5.js",
    errorDialog: false,
    errorList: [],
    step: 1
  }),
  methods: {
    getNiceDateTime(value) {
      return moment(value).format("DD.MM.YYYY HH:mm");
    },
    userById(id) {
      if (!id) return "";
      const user = this.users.find(u => u.id === id || u._id === id);
      if (user?.first_name && user?.last_name)
        return `${user.first_name} ${user.last_name}`;
      else return null;
    }
  },
  computed: {
    mainFiles: {
      get() {
        return [this.servicePackage?.image] ?? [];
      },
      set(value) {
        this.servicePackage.image = value[0];
      }
    },
    users() {
      return this.$store.state.users;
    }
  }
};
